import { Box, Typography } from '@mui/material'
import FormRow from 'components/form/FormRow'
import AutocompleteInput from 'components/form/input/AutocompleteInput'
import DateInput from 'components/form/input/DateInput'
import SelectInput from 'components/form/input/SelectInput'
import TextInput from 'components/form/input/TextInput'
import React from 'react'

export default function PainelConfiguracoes({ dataFinal, dateToString }) {
    return (
        <Box sx={{ px: { xs: 1, sm: 2 } }}>
            <Box sx={{ mb: 3 }}>
                <Typography variant="h6" sx={{ mb: 2, color: 'primary.main' }}>
                    Configurações Gerais
                </Typography>

                <FormRow>
                    <SelectInput
                        name="tipoAncora"
                        label="Tipo de Ancora (Comprador/Vendedor)"
                        options={["Comprador", "Vendedor", "Sem Ancora"]}
                        required
                    />
                    <SelectInput
                        name="bloqueiaCnpjDuplicado"
                        label="Bloquear CNPJ Duplicado"
                        options={["SIM", "NÃO"]}
                        required
                        helperText="Impede novas inscrições com o mesmo CNPJ ou CPF de empresa"
                    />
                    <SelectInput
                        name="rodadaInternacional"
                        label="Rodada Internacional"
                        options={["SIM", "NÃO"]}
                        required
                        helperText="Impede que novos cadastros validem Município, CPF e CNPJ"
                    />
                </FormRow>
                <FormRow>
                    <TextInput name="emailContato" label="Email de Contato da Rodada" />
                    <TextInput name="telefoneContato" label="Telefone Whatsapp de Contato da Rodada" type="number" />
                </FormRow>

            </Box>

            <Box>
                <Typography variant="h6" sx={{ mb: 2 }}>
                    Configurações de Inscrição
                </Typography>
                <FormRow>
                    <SelectInput
                        name="bloqueiaInscricaoPublica"
                        label="Bloquear inscrições pelos links públicos"
                        options={["SIM", "NÃO"]}
                        required
                        helperText="Impede novos cadastros atraves dos links públicos"
                    />

                    <SelectInput
                        name="permiteFotosInscricao"
                        label="Permite anexar fotos nas Inscrições"
                        options={["SIM", "NÃO"]}
                        required
                    />

                    <DateInput
                        name="limiteInscricaoPublica"
                        label="Data limite para incrição por link público"
                        showTime
                        inputProps={{
                            style: { textTransform: "uppercase" },

                            max: dateToString(dataFinal),
                        }}
                    />
                </FormRow>
                <FormRow>
                    <SelectInput
                        name="redirecionaPainelDeInscricao"
                        label="Redireciona para o Painel de Inscrição após o cadastro"
                        options={["SIM", "NÃO"]}
                        required
                    />
                    <AutocompleteInput
                        name="restricaoEstado"
                        label="Inscrições restritas ao estado:"
                        options={[
                            "AC", "AL", "AP", "AM", "BA", "CE", "DF", "ES", "GO", "MA",
                            "MT", "MS", "MG", "PA", "PB", "PR", "PE", "PI", "RJ", "RN",
                            "RS", "RO", "RR", "SC", "SP", "SE", "TO"
                        ]}
                        freeSolo
                        clearOnBlur
                        handleHomeEndKeys
                        multiple
                        isOptionEqualToValue={(option, value) => option === value}
                    />
                </FormRow>
            </Box>

            <Box>
                <Typography variant="h6" sx={{ mb: 2 }}>
                    Configurações do Painel do Inscrito
                </Typography>
                <FormRow>

                    <SelectInput
                        name="painelInscrito.habilitaRelCatalogo"
                        label="Habilita impressão do catálogo"
                        options={["SIM", "NÃO"]}
                        required
                    />
                    <SelectInput
                        name="painelInscrito.habilitaRelAgenda"
                        label="Habilita impressão do agenda de reuniões"
                        options={["SIM", "NÃO"]}
                        required
                    />
                </FormRow>
                <FormRow>
                    <SelectInput
                        name="painelInscrito.redirecionaParaPainelInscrito"
                        label="Redireciona para o Painel do Inscrito após a inscrição"
                        options={["SIM", "NÃO"]}
                        required
                    />

                    <SelectInput
                        name="painelInscrito.exibeAgenda"
                        label="Exibe agenda de reuniões na página do inscrito"
                        options={["SIM", "NÃO"]}
                        required
                    />
                </FormRow>
            </Box>
        </Box>
    )
}
